import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";
import { BagsCashReportEntry } from "@/model/data/bagsCashReport/BagsCashReportEntry";

export class GetBagsCashReportResData extends ServiceResponseData {
    bagsCashReportEntries: BagsCashReportEntry[] = [];
    bagsCashReportTotals: BagsCashReportEntry[] = [];

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.BagsCashReportEntries && obj.BagsCashReportEntries.length > 0) {
            this.bagsCashReportEntries = [];
            obj.BagsCashReportEntries.forEach((obj) => {
                var temp = new BagsCashReportEntry();
                temp.parse(obj);
                this.bagsCashReportEntries.push(temp);
            });
        }

        if (obj.BagsCashReportTotals && obj.BagsCashReportTotals.length > 0) {
            this.bagsCashReportTotals = [];
            obj.BagsCashReportTotals.forEach((obj) => {
                var temp = new BagsCashReportEntry();
                temp.parse(obj);
                this.bagsCashReportTotals.push(temp);
            });
        }
    }
}
